import "../../assets/css/community-info.css";
import { useContext, useState } from "react";
import Panel from "../Panel/PanelShimmer";
import StateContext from "../../state/stateContext";
import useQueryChildData from "../Hooks/useQueryChildData";
import Image from "../Image/Image";
import { mapChildData } from "../../helpers/helpers";
import appSettings from "../../settings/appSettings";
const { core2="https://mywv.worldvision.org" } = appSettings?.urls;

export function CommunityInfo(props) {
   const context = useContext(StateContext);
   const queryChildData = useQueryChildData(context);
   const [imageStatus, setImageStatus] = useState("loading");
   const { childInfo } = context.state;
   const mappedChildData = mapChildData(childInfo?.data || {});
   const communityName = childInfo?.data?.projectName?.trim() || "";
   const givenName = childInfo?.data?.givenName || "";
   const hisHer = mappedChildData?.hisHer || "";
   const projectId = childInfo?.data?.projectIdentifier || "";
   const communityUrl = `${core2}/my/community?ID=${projectId}&CNAME=${givenName}`;
   const countryCode = childInfo?.data?.countryCode?.toLowerCase();
   const countryThumbnail = `https://wvusstatic.com/countries/banners/thumb/${countryCode}-thumb.jpg`;
   const defaultThumbnail = "https://wvusstatic.com/countries/banners/thumb/default-thumb.jpg";

   if (queryChildData.isError) {
      return null;
   }

   return (
      <Panel classList="community-info__panel" showShimmer={queryChildData.isWaiting} shimmerProps={{height:"280px"}}>
         <h3 className="eta">{communityName} community</h3>
         <Image 
            src={countryThumbnail} 
            fallbackSrc={defaultThumbnail}
            onLoad={setImageStatus}
         />
         <p>Step inside {givenName}'s world - learn about the challenges and progress in {hisHer} community</p>
         <a href={communityUrl}>Explore {hisHer} community</a>
      </Panel>
   );
}
  
export default CommunityInfo;